import React from 'react';
import ManageExportFileSpecVM from './ManageExportFileSpecVM';
import { observer } from 'mobx-react';
import { Neo } from '@singularsystems/neo-react';
import { ModalUtils } from '@singularsystems/neo-core';
import { TextConstants } from '../../../Common/TextConstants';
import { StoredProcedureSchemaEnum } from '../../../Common/Enums/StoredProcedureSchemaEnum';

interface IManageExportFileSpecProps {
    viewModel: ManageExportFileSpecVM;
    onCancel: () => void;
    onSave: () => void;
}

@observer
export default class ManageExportFileSpec extends React.Component<IManageExportFileSpecProps> {
    public render() {
        const viewModel = this.props.viewModel;
        return (
            <>
                {<Neo.Card title={viewModel.managedExportFileSpecLookupModel.staticExportFileSpecId === 0 ? TextConstants.Titles.AddNewExportFileSpec : TextConstants.Titles.EditExportFileSpec}>
                    <Neo.Form
                        model={viewModel.managedExportFileSpecLookupModel}
                        onInvalid={this.onFormInvalid}
                        onSubmit={() => this.props.onSave()}
                        >
                        <div className="row">
                            <div className="col lg-4">
                                <Neo.FormGroup
                                    label={TextConstants.Labels.ExportReport}
                                    bind={viewModel.managedExportFileSpecLookupModel.meta.reportSpecName}
                                    isReadOnly={viewModel.isFieldReadonlyInd}
                                    placeholder={TextConstants.PlaceHolder.ExportReportPlaceholder} />
                            </div>
                            <div className="col-lg-7">
                                <Neo.FormGroup bindContext={viewModel.managedExportFileSpecLookupModel.meta.reportProcedureName}>
                                    <Neo.AutoCompleteDropDown
                                        itemSource={(searchCriteria) => viewModel.checkQueryApiClient.getStoredProcedureDropdownList(searchCriteria, StoredProcedureSchemaEnum.ReportProcs)}
                                        bind={viewModel.managedExportFileSpecLookupModel.meta.reportProcedureName}
                                        bindDisplay={viewModel.managedExportFileSpecLookupModel.meta.reportProcedureName}
                                        displayMember={"storedProcedure"}
                                        items={viewModel.checkQueryApiClient.getStoredProcedureDropdownList(" ", StoredProcedureSchemaEnum.ReportProcs).then((arr) => arr.data.slice(0,10)
                                        .sort((x,y) => x.storedProcedure.localeCompare(y.storedProcedure)))}
                                        />
                                </Neo.FormGroup>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-4">
                                <Neo.FormGroup
                                    label="Format"
                                    bind={viewModel.managedExportFileSpecLookupModel.meta.format}
                                    isReadOnly={viewModel.isFieldReadonlyInd}
                                />
                            </div>
                        </div>
                        <div className="row customMarginTop29 float-right pr-3">
                            <Neo.Button
                                variant="primary" className="ml-3 col-lg-2"
                                onClick={() => viewModel.showConfirmSaveModal()}
                            >{TextConstants.Buttons.Save}</Neo.Button>
                            <Neo.Button className="ml-3 col-lg-2"
                                onClick={() => this.props.onCancel()}
                                variant="secondary"
                            >{TextConstants.Buttons.Cancel}</Neo.Button>
                        </div>
                    </Neo.Form>
                </Neo.Card>
                }{viewModel.showConfirmSaveComponent &&  
                    <>
                        {
                            viewModel.isValid
                            &&
                            <Neo.Modal
                                title="Confirm Save"
                                bind={viewModel.meta.managedExportFileSpecLookupModel}
                                closeButton={{ text: "No", variant: "secondary", isOutline: true, onClick: () => viewModel.closeConfirmationModal() }}
                                acceptButton={{ text: "Yes", variant: "primary", onClick: () => this.onSave(viewModel)}}
                            > {
                                viewModel.managedExportFileSpecLookupModel.staticExportFileSpecId === 0 && !viewModel.managedExportFileSpecLookupModel.isCreatedFromPreviousVersion ? TextConstants.GeneralText.NewFileSpecSave : TextConstants.GeneralText.VersionOfFileSpecOverlaps
                            }
                            </Neo.Modal>
                        }
                    </>
                }
            </>
        );
    }
    private onFormInvalid(e: React.FormEvent, justValidated?: boolean) {
        if (!justValidated) {
            ModalUtils.showMessage("Save", TextConstants.Validation.InvalidFileConfiguration);
        }
    }

    private onSave(vm: ManageExportFileSpecVM) {
        vm.confirmSave();
        this.props.onSave();
    }
}